import { render, staticRenderFns } from "./MoreAction.vue?vue&type=template&id=2bb4923c&"
import script from "./MoreAction.vue?vue&type=script&lang=js&"
export * from "./MoreAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports